module.exports = __webpack_public_path__ + "static/media/3DPPA34.b895dabc.jpg";